module.exports = __webpack_public_path__ + "img/title_4.31fa59bb.png";